module.exports = __webpack_public_path__ + "static/media/Punjab Assembly.3586b87b.jpg";